import { Service } from "@/modules/Services/models/Service";
import axios from "axios";
import { Response } from "../../../shared/models/Response";
import { MedicalOrderModel } from "../models/MedicalOrderModel";
import { LoadOrdersError } from "../models/LoadOrdersError";
import { MedicalOrderPreviewEventTimelineModel } from "../models/MedicalOrderPreviewEventTimelineModel";
import { MedicalOrderFilter } from "@/modules/Dashboards/AdminDashboard/models/MedicalOrderFilter";
import { MedicalOrderUpdateModel } from "../models/MedicalOrderUpdateModel";

export class MedicalOrderService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = `${process.env.VUE_APP_FORMS_API}/medical-orders`;
  }

  async checkMedicalOrderByServiceTemplate(
    serviceTempId: string,
    user: string
  ): Promise<Response<string>> {
    const serviceURL = `${this.baseUrl}/check-by-service/${serviceTempId}/${user}`;
    const response = await axios.get(serviceURL);
    return response.data;
  }

  async saveMedicalOrder(
    service: Service,
    order: MedicalOrderModel
  ): Promise<Response<string>> {
    const serviceURL = `${this.baseUrl}/assign-medical-order`;
    const response = await axios.post(serviceURL, { service, order });
    return response.data;
  }

  async createMedicalOrders(
    data: Record<string, any>[]
  ): Promise<Response<void | LoadOrdersError[]>> {
    const serviceURL = `${this.baseUrl}/create-massive-orders`;
    const response = await axios.post(serviceURL, data);
    return response.data;
  }

  async getMedicalOrderById(
    id: string
  ): Promise<Response<MedicalOrderPreviewEventTimelineModel>> {
    const serviceURL = `${this.baseUrl}/${id}`;
    const response = await axios.get(serviceURL);
    return response.data;
  }

  async getMedicalOrderByFilter(
    query: MedicalOrderFilter
  ): Promise<Response<MedicalOrderModel>> {
    const serviceURL = `${this.baseUrl}/by-filters`;
    const response = await axios.get(serviceURL, { params: query });
    return response.data;
  }

  async updateMedicalOrder(
    id: string,
    medicalOrder: MedicalOrderUpdateModel
  ): Promise<Response<string>> {
    const serviceURL = `${this.baseUrl}/update-medical-order/${id}`;
    const response = await axios.put(serviceURL, medicalOrder);
    return response.data;
  }
}
